import { getDefaultFontFamily } from './get-default-font-family';

const TRAILING_SEMICOLON = /;$/;

export function getFontFamily(): string {
  const fontFamily = getComputedStyle(document.body).getPropertyValue('--fontFamily').trim();

  if (!fontFamily) {
    return getDefaultFontFamily();
  }

  return fontFamily.replace(TRAILING_SEMICOLON, '');
}
